import {
  ColumnLayoutEnum,
  TCardColumnLayoutFields,
  TCardColumnLayoutParams,
  TCardColumnLayoutProps,
  TCardItem,
} from '../types/cardColumnLayout.types';
import { TStringField } from '../../../types/sitecore.types';
import { LinkField, THeadingTag } from '../../../types/types';
import { getFollowingHTag } from '../../../utils/seo.utils';

export class CardColumnLayoutModel {
  private readonly fields?: TCardColumnLayoutFields;
  private readonly params?: TCardColumnLayoutParams;

  constructor(props: TCardColumnLayoutProps) {
    this.fields = props?.fields || undefined;
    this.params = props?.params || undefined;
  }

  get layout(): string | ColumnLayoutEnum {
    return this.fields?.columnLayout?.fields?.Key?.value || '';
  }

  get title(): TStringField | undefined {
    return this.fields?.sectionHeading;
  }

  get eyebrow(): TStringField | undefined {
    return this.fields?.sectionEyebrow;
  }

  get subtitle(): TStringField | undefined {
    return this.fields?.sectionSubheading;
  }

  get link(): LinkField | undefined {
    return this.fields?.sectionCtaTextLink;
  }

  get cards(): TCardItem[] {
    return this.fields?.items || [];
  }

  get backgroundColor(): string {
    return this.fields?.componentBgColor?.fields?.Key?.value?.toLowerCase() || 'white';
  }

  get textColor(): string {
    return this.fields?.textElementColor?.fields?.Key?.value?.toLowerCase() || 'black';
  }

  get primaryCtaColor(): string {
    return this.fields?.primaryCtaStyle?.fields?.Key?.value?.toLowerCase() || 'primary-orange';
  }

  get secondaryCtaColor(): string {
    return this.fields?.secondaryCtaStyle?.fields?.Key?.value?.toLowerCase() || 'secondary-black';
  }

  get rowsPerPage(): number {
    return Number(this.fields?.rowsPerPage?.value) || 6;
  }

  get totalCardsCount(): number {
    return Number(this.fields?.totalCardsCount);
  }

  get isLabelIndicatorShown(): boolean {
    return !this.fields?.hideLabelIndicator?.value;
  }

  get isUiLineIndicatorShown(): boolean {
    return !this.fields?.hideUiLineIndicator?.value;
  }

  get isShowInMobile(): boolean {
    return !!this.fields?.showInMobile?.value;
  }

  get dataSource(): string {
    return this?.fields?.dataSource || '';
  }

  get hasIconCard(): boolean {
    return !!this?.fields?.items?.find((_) => _.fields?.icon?.fields?.iconKey?.value);
  }

  get headingTag(): THeadingTag {
    return (this.params?.headingTag?.toLowerCase() as THeadingTag) || 'h2';
  }
  get cardHeadingTitleTag(): THeadingTag {
    return getFollowingHTag(this.headingTag);
  }

  get isUnreleased(): boolean {
    return !!this.fields?.isComponentUnreleased;
  }
}
